import React, { ReactElement, Suspense } from 'react';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';
import { IFilterInput } from '../../graphql/schema/p4types';
import { IWorkspaceProps } from '../../@types/workspaceTypes';
import FluentModal from '../modals/FluentModal';

type IWorkspaceModalProps = {
  component: (props: IWorkspaceProps<any>) => ReactElement | null;
  viewScreenName: string;
  closeModal: () => void;
  modalState: { modalOpen: boolean; filters?: Array<IFilterInput> };
  onRowDoubleClickOverride?: IWorkspaceProps<any>['onRowDoubleClickOverride'];
};

export default ({
  component: WorkspaceComponent,
  viewScreenName,
  closeModal,
  modalState: { modalOpen: isOpen, filters = [] },
  onRowDoubleClickOverride,
}: IWorkspaceModalProps) => {
  return (
    <WorkspaceModalOnly isOpen={isOpen}>
      <WorkspaceComponent
        viewScreenName={viewScreenName}
        predefinedFilters={filters}
        backButtonRequired={true}
        embeddedView={true}
        lookupView={true}
        onBack={closeModal}
        editInNewTab={true}
        onRowDoubleClickOverride={onRowDoubleClickOverride}
      />
    </WorkspaceModalOnly>
  );
};

//Just the modal part from above, so we have full control over the rendered workspace component.
export const WorkspaceModalOnly = ({ children, isOpen }: { children: any; isOpen: boolean }) => {
  return (
    <FluentModal isOpen={isOpen}>
      <div style={{ position: 'relative', height: '90vh', width: '80vw' }}>
        <Suspense fallback={<ProgressIndicator />}>{children}</Suspense>
      </div>
    </FluentModal>
  );
};
